import React, {useEffect} from 'react';
import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import Footer from '../../partials/Footer';
import Blog3skey from '../../partials/Blog3skey';

function Blog3skeyDigital() {

  useEffect(() => {
    document.title = `Sécurisez vos opérations bancaires avec 3SKey | CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <Blog3skey />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Blog3skeyDigital;